import React, { useState } from "react";
import api from "../../api/api";
import dayjs from "dayjs";
import { getPracticeId } from "../../config/practice";

const QUARTERS = ["q1", "q2", "q3", "q4"];

const QualityRiskApptsModal = ({
  open,
  onClose,
  patientid,
  initialDates,
  setToastMessage,
  setToastSeverity,
  setOpenToast,
  refreshDashboard,
}) => {
  const practiseid = getPracticeId();
  const [quarterDates, setQuarterDates] = useState(
    initialDates || { q1: "", q2: "", q3: "", q4: "" }
  );
  const [editingQuarter, setEditingQuarter] = useState(null);
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await api.put(
        `/v1/${practiseid}/patient/${patientid}/updateQualityRiskAppts`,
        quarterDates
      );
      if (res.status === 200) {
        setToastMessage("Updated successfully");
        setToastSeverity("success");
        setOpenToast(true);
        setEditingQuarter(null);
        onClose();
        // if (refreshDashboard) refreshDashboard();
      } else {
        setToastMessage("Failed to update. Please try again.");
        setToastSeverity("error");
        setOpenToast(true);
      }
    } catch (e) {
      setToastMessage("Failed to update. Please try again.");
      setToastSeverity("error");
      setOpenToast(true);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-[560px] min-h-[420px] p-8 flex flex-col gap-6">

        {/* Header */}
        <div className="relative flex items-center justify-center">
          <div className="font-inter font-semibold text-[22px] text-[#1D2951] text-center">
            Quality Risk Appointments
          </div>
          <button
            className="absolute right-0 text-gray-400 hover:text-gray-600 text-2xl font-bold leading-none"
            onClick={onClose}
          >
            ×
          </button>
        </div>

        {/* Quarters grid */}
        <div className="grid grid-cols-2 gap-4">
          {QUARTERS.map((q, i) => {
            const hasDate = !!quarterDates[q];
            const isEditing = editingQuarter === q;

            return (
              <div
                key={q}
                className="border border-gray-200 rounded-lg p-4 min-h-[110px] flex flex-col gap-3"
              >
                <div className="font-inter font-medium text-[15px] text-[#1D2951]">
                  Quarter {i + 1}
                </div>

                {isEditing ? (
                  <input
                    autoFocus
                    type="date"
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-[14px] font-inter focus:outline-none focus:ring-2 focus:ring-[#800080]"
                    value={quarterDates[q]}
                    onChange={(e) =>
                      setQuarterDates((prev) => ({ ...prev, [q]: e.target.value }))
                    }
                    onBlur={() => setEditingQuarter(null)}
                  />
                ) : hasDate ? (
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-inter text-[14px] text-[#0F172B]">
                      {dayjs(quarterDates[q]).isValid()
                        ? dayjs(quarterDates[q]).format("MMM DD, YYYY")
                        : quarterDates[q]}
                    </span>
                    <button
                      type="button"
                      className="text-[12px] font-inter text-[#800080] hover:underline"
                      onClick={() => setEditingQuarter(q)}
                    >
                      Edit
                    </button>
                  </div>
                ) : (
                  <div className="flex items-center justify-between gap-2">
                    <span className="font-inter text-[13px] text-gray-400">
                      No date found
                    </span>
                    <button
                      type="button"
                      className="text-[12px] font-inter text-[#800080] hover:underline whitespace-nowrap"
                      onClick={() => setEditingQuarter(q)}
                    >
                      + Add Date
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* Actions */}
        <div className="flex gap-3 mt-2">
          <button
            className="flex-1 py-2 rounded-lg border border-gray-300 text-[13px] font-inter text-gray-600 hover:bg-gray-50"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            disabled={saving}
            className="flex-1 py-2 rounded-lg text-[13px] font-inter text-white font-medium hover:opacity-90 disabled:opacity-60"
            style={{ background: "#800080" }}
            onClick={handleSave}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>

      </div>
    </div>
  );
};

export default QualityRiskApptsModal;
